import { MassTextApprovalDecision } from '@chiroup/core/types/MassText.type';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import bulkCampaignApprovalsService, {
  BulkCampaignApprovalQueue,
} from '../services/bulkCampaignApprovals.service';

const QUEUE_QUERY_KEY = ['bulk-campaign-approvals'] as const;

export const useBulkCampaignApprovals = (enabled = true) =>
  useQuery<BulkCampaignApprovalQueue>(QUEUE_QUERY_KEY, () => bulkCampaignApprovalsService.list(), {
    refetchOnWindowFocus: true,
    refetchInterval: 30_000,
    enabled,
  });

export const useDecideBulkCampaignApproval = () => {
  const queryClient = useQueryClient();

  return useMutation<
    BulkCampaignApprovalQueue,
    unknown,
    { clinicId: number; campaignId: number; decision: MassTextApprovalDecision }
  >(
    ({ clinicId, campaignId, decision }) =>
      bulkCampaignApprovalsService.decide(clinicId, campaignId, decision),
    {
      onSuccess: () => queryClient.invalidateQueries(QUEUE_QUERY_KEY),
    }
  );
};
